import $ from 'jquery';
import {getWidth, onResize} from "../utils/window";

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');
	const banner = $('.banner.-desk');

	if (headerToggler) {

		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);

			if (headerToggler.isOpen) {
				$scroller.animate({ scrollTop: 0 }, { duration: 200 });
			}
		});

		$('.header_button.-type-search').click(function () {
			const $this = $(this);

			if ($this.hasClass('is-open')) {
				$('#header-search .header-form_form #header-search_input').focus();
			}
		});
	}

	$(function() {

		function updateHeader() {
			$('.cart-padding, .header-search-padding').css('height', banner.outerHeight());
			$('.header.-overlay.-banner').css('top', banner.outerHeight());
		}

		if (banner.length) {
			updateHeader();

			onResize(updateHeader);
		}
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js